import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    IAddBulkInvoicePayment,
    IAddBulkInvoicePaymentResponse,
    IDeleteInvoiceNote,
    IEditInvoiceNote,
} from "../types/billing.types";
import {
    addBulkInvoicePayment,
    deleteInvoiceNote,
    editInvoiceNote,
} from "../services/billing.services";
import { IInvoiceNotesResponse } from "../../../utils/types/billing";

export function useAddBulkInvoicePayment() {
    return useMutation<
        IApiResponse<IAddBulkInvoicePaymentResponse>,
        AxiosError<IApiResponse<IAddBulkInvoicePaymentResponse>>,
        IAddBulkInvoicePayment
    >({
        mutationKey: ["bulk-invoice-payment"],
        mutationFn: (payload: IAddBulkInvoicePayment) =>
            addBulkInvoicePayment(payload),
    });
}

export function useDeleteInvoiceNote() {
    return useMutation<
        IApiResponse<void>,
        AxiosError<IApiResponse<void>>,
        IDeleteInvoiceNote
    >({
        mutationKey: ["delete-invoice-note"],
        mutationFn: (payload: IDeleteInvoiceNote) => deleteInvoiceNote(payload),
    });
}

export function useEditInvoiceNote(invoiceId: string, invoiceNoteId: string) {
    return useMutation<
        IApiResponse<IInvoiceNotesResponse>,
        AxiosError<IApiResponse<IInvoiceNotesResponse>>,
        IEditInvoiceNote
    >({
        mutationKey: ["edit-invoice-note"],
        mutationFn: (payload: IEditInvoiceNote) =>
            editInvoiceNote(invoiceId, invoiceNoteId, payload),
    });
}
